import { Box } from "@mui/material";

export const MuiBox = Box;
